import { UserStatus, UserStatusAction } from '../types';

export const actionCodeByUserStatus: Record<UserStatus, UserStatusAction> = {
    active: UserStatusAction.block,
    inactive: UserStatusAction.activate,
    blocked: UserStatusAction.unblock,
};
